import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const validateEducationalCenterGrading = yup.object().shape({
  points: yup
    .number()
    .typeError(LOCALE.points + LOCALE.must_be_number)
    .required(LOCALE.points + LOCALE.must_be_number)
    .positive(LOCALE.points + LOCALE.must_be_positive),
  attachments: yup.array().required(LOCALE.required_at_least_one_attachment),
});
